module.exports = __webpack_public_path__ + "static/media/mx.45ad2f66.png";